module.exports = __webpack_public_path__ + "assets/retina_OrthicTriangleDetailed.6b99878b818a1d0ac32bcaf07eff29e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_OrthicTriangleDetailed.png
// module id = 696
// module chunks = 0